var $uploadCrop,
    tempFilename,
    rawImg,
    imageId;

function readFile(input){
    if (input.files && input.files[0]) {
        // if (checkImage(input.files[0])) {
            var reader = new FileReader();
        img = $('<img />');
            reader.onload = function (e) {
                // $('.upload-demo').addClass('ready');
                // $('#cropImagePop').modal('show');
                rawImg = e.target.result;
                if (rawImg) {
                    var img =   $(".image-output img");
                    img.attr("src", rawImg);
                    img.prop('src',reader.result);
                    img.src = img.prop('src');
                    var orientation;
                    EXIF.getData(img, function() {
                        orientation = EXIF.getTag(this, "Orientation");
                    });

                    const ORIENT_TRANSFORMS = {
                        1: '',
                        2: 'rotateY(180deg)',
                        3: 'rotate(180deg)',
                        4: 'rotate(180deg) rotateY(180deg)',
                        5: 'rotate(270deg) rotateY(180deg)',
                        6: 'rotate(90deg)',
                        7: 'rotate(90deg) rotateY(180deg)',
                        8: 'rotate(270deg)'
                    };

                    img.css("transform",ORIENT_TRANSFORMS[orientation]);


                    if (document.getElementById('addCandidate')) {
                        $('#addCandidate').data('formValidation').isValidField("avatar");
                    }
                    if (document.getElementById('employerForm')) {
                        $('#employerForm').data('formValidation').isValidField("avatar");
                    }
                } else {
                    $(".image-output img").attr("src", "/img/user-icon.png");
                }
            };
            reader.readAsDataURL(input.files[0]);
        // }
    } else {
        // alert("Sorry - you're browser doesn't support the FileReader API");
    }
}

// $uploadCrop = $('#upload-demo').croppie({
//     viewport: {
//         width: 145,
//         height: 145,
//         type: 'circle'
//     },
//     boundary: {width: 200, height: 200},
//     enableExif: true
// });
// $('#cropImagePop').on('shown.bs.modal', function () {
//     // alert('Shown pop');
//     $uploadCrop.croppie('bind', {
//         url: rawImg
//     }).then(function () {
//
//     });
// });


// function checkImage(file) {
//     if(file.size > 20971520) {
//         return false;
//     }
//     var fileTypes = ["jpeg", "jpg", "png", "eps", "tiff", "bmp"];
//     var tmp = 0;
//     for(var i = 0; i < fileTypes.length; i++) {
//         if (file.type.indexOf(fileTypes[i]) == -1) {
//             tmp++;
//         }
//     }
//     if(tmp == fileTypes.length){
//         return false;
//     }
//     return true;
// }

// $('.item-img').on('change', function () {
//     imageId = $(this).data('id');
//     tempFilename = $(this).val();
//     $('#cancelCropBtn').data('id', imageId);
//     readFile(this);
// });

$('.addimg').on('change', function(){
    imageId = $(this).data('id');
    tempFilename = $(this).val();
    $('#cancelCropBtn').data('id', imageId);
    readFile(this);
});

// $('#cropImageBtn').on('click', function (ev) {
//     $uploadCrop.croppie('result', {
//         type: 'base64',
//         format: 'jpeg',
//         size: {width: 1000, height: 1000}
//     }).then(function (resp) {
//         // $('input[name=av]').val(resp);
//         // console.log($('input[name=avatar]').prop('files'))
//
//         $('#item-img-output').attr('src', resp);
//         $('#cropImagePop').modal('hide');
//
//         if (document.getElementById('addCandidate')) {
//             $('#addCandidate').data('formValidation').isValidField("avatar");
//         }
//         if (document.getElementById('employerForm')) {
//             $('#employerForm').data('formValidation').isValidField("avatar");
//         }
//     });
// });